/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookOpenText: {
  name: 'book-open-text';
  data: string;
} = {
  name: 'book-open-text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 5.28a2 2 0 0 0-2.485-1.94L12 4.97 5.485 3.34A2 2 0 0 0 3 5.28v11.94a2 2 0 0 0 1.515 1.94l7 1.75c.047.011.094.021.142.03a.998.998 0 0 0 .686 0c.048-.009.095-.019.142-.03l7-1.75A2 2 0 0 0 21 17.22V5.28Zm-8 13.44 6-1.5V5.28l-6 1.5v11.94ZM11 6.78l-6-1.5v11.94l6 1.5V6.78Zm6.894 1.773a1 1 0 0 1-.447 1.341l-2 1a1 1 0 1 1-.894-1.788l2-1a1 1 0 0 1 1.341.447Zm-.447 6.341a1 1 0 1 0-.894-1.788l-2 1a1 1 0 1 0 .894 1.788l2-1Z" fill="currentColor"/></svg>`,
};
